import React from "react";
import { showLocalDate } from "../../../utilities/functions";

const InitialDate = ({ row }) => {
  return <div>{row?.initialDate ? showLocalDate(row?.initialDate) : ""}</div>;
};

export default InitialDate;
